<template>
  <div class="table-wrapper" :class="{ 'fold-active' : isFold }">
    <board-loading :loading-state="isLoading"/>

    <board-pagination :pagination-template="config.paginationTemplate"
                      :on-change-page="onChangePage"
                      :on-each-side="config.onEachSide || 1"
                      ref="pagination">

      <search-bar class="search-bar"/>

      <button-group class="button-group-wrapper"
                    :selected-count="selectedCount"
                    :disabled-insert="insertRowFunction === undefined"
                    :disabled-delete="deleteRowFunction === undefined"
                    :insert-row-function="() => { insertRow(insertRowFunction) }"
                    :delete-row-function="() => { deleteRow(deleteRowFunction) }"/>

    </board-pagination>

    <div class="overflow-table">
      <vuetable v-if="isSuccessPreload" ref="vuetable"
                :api-url="config.apiUrl"
                :fields="config.fields"
                :data-path="config.dataPath"
                :http-options="httpOptions"

                :pagination-path="config.paginationPath"

                :sort-order="config.sortOrder"
                :track-by="config.trackBy"
                :detail-row-component="config.detailRowComponentName"

                :append-params="moreParams"
                :multi-sort="isMultiSort"
                :per-page="perPage"

                :row-class="onRowClass"

                @vuetable:pagination-data="onPaginationData"
                @vuetable:loading="onLoading"
                @vuetable:load-success="onLoadingSuccess"
                @vuetable:checkbox-toggled="onCheckboxToggle"
                @vuetable:checkbox-toggled-all="onCheckboxToggleAll">

        <template slot="actions" slot-scope="props">

          <custom-actions :row-data="props.rowData"
                          :custom-action-component-name="config.customActionComponentName"
                          :play-action="playButtonFunction"
                          :is-modify-disabled="disabledModifyButton"
                          :is-delete-disabled="disabledDeleteButton"
                          :is-play-disabled="disabledPlayButton"
                          :toggle-detail-row-function="toggleDetailRow"
                          :track-by="config.trackBy"/>

        </template>

      </vuetable>

    </div>

    <button-group class="mobile-button-group-wrapper"
                  :selected-count="selectedCount"
                  :disabled-insert="insertRowFunction === undefined"
                  :disabled-delete="deleteRowFunction === undefined"
                  :insert-row-function="() => { insertRow(insertRowFunction) }"
                  :delete-row-function="() => { deleteRow(deleteRowFunction) }"/>

    <search-bar class="mobile-search-bar"/>

  </div>
</template>

<script>
import Vue from 'vue';
import VueEvents from 'vue-events';
import Vuetable from 'vuetable-2/src/components/Vuetable';

import BoardPagination from './components/pagination/BoardPagination';

import BoardBinderMixin from './components/mixins/BoardBinderMixin';
import BoardMethodMixin from './components/mixins/BoardMethodMixin';
import BoardPreloadMixin from './components/mixins/BoardPreloadMixin';
import BoardFields from './components/mixins/BoardFields';

import BoardLoading from './components/BoardLoading';
import ButtonGroup from './components/ButtonGroup';

import CustomActions from './components/CustomActions';

import SearchBar from './components/search/SearchBar';

Vue.use(VueEvents);

export default {
  name: 'BoardTable',
  mixins: [BoardBinderMixin, BoardMethodMixin, BoardFields, BoardPreloadMixin],
  components: {
    Vuetable,
    CustomActions,
    BoardLoading,
    BoardPagination,
    ButtonGroup,
    SearchBar,
  },
  props: {
    config: {
      type: Object,
      isRequired: true,
    },

    httpOptions: {
      type: Object,
      default: () => ({}),
    },

    isFold: {
      type: Boolean,
      isRequired: true,
    },

    insertRowFunction: {
      type: Function,
      isRequired: true,
    },

    deleteRowFunction: {
      type: Function,
      isRequired: true,
    },

    playButtonFunction: {
      type: Function,
      default: () => {},
    },

    isMultiSort: {
      type: Boolean,
      default: true,
    },

    disabledPlayButton: {
      type: Boolean,
      default: false,
    },

    disabledModifyButton: {
      type: Boolean,
      default: false,
    },

    disabledDeleteButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  width: calc(100vw - 280px);
  height: 100%;

  transition: width ease-in-out 0.5s;

  .overflow-table {
    height: calc(100vh - 150px);
    overflow: scroll;
  }
}

.fold-active {
  width: calc(100vw - 60px);
}

.mobile-search-bar {
  display: none;
}

.mobile-button-group-wrapper {
  display: none !important;
}

@media screen and (max-width: 1024px) {
  .table-wrapper {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column-reverse;

    .overflow-table {
      height: 95%;
    }
  }

  .fold-active {
    width: 100%;
  }

  .search-bar {
    display: none;
  }

  .mobile-search-bar {
    display: block;
  }

  .button-group-wrapper {
    display: none !important;
  }

  .mobile-button-group-wrapper {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/table/BoardTable.vue